/* eslint-disable array-callback-return, no-unused-vars, no-nested-ternary */

import FileUpload from '@gameday/react-components/components/FileUpload'
import { get, isArray, isObject, remove } from 'lodash'
import { useState } from 'react'
import styled from 'styled-components'

import { upload } from '../../../functions/documents'

const StyledFileUpload = styled.div`
  .choose {
    color: var(--custom-primary-color);
  }
`

function Component({
  formData,
  label,
  maxSize,
  multiple,
  onFileUploaded = () => {},
  onFileUploading = () => {},
  onFileDeleted = () => {},
  value,
  isMandatory,
  errorText,
  disabled,
  ...rest
}) {
  const progressSync = {}
  const uploadedFiles = []
  const [progress, setProgress] = useState({})
  const [uploading, setUploading] = useState(false)
  const [success, setSuccess] = useState(undefined)
  const [error, setError] = useState(undefined)
  // biome-ignore lint/correctness/noUnusedVariables: TODO
  const [files, setFiles] = useState({})

  const setUploadProgress = (fileName, progressObj) => {
    setError(undefined)
    progressSync[fileName] = {
      ...(progressSync[fileName] ? progressSync[fileName] : {}),
      ...progressObj,
    }
    setProgress({ ...progressSync })
  }

  const onCancel = file => {
    progress[file.name].onCancel()
  }

  const fileList = isArray(value) ? (value || []).map(f => f.file) : value

  const onDelete = file => {
    const newFiles = value.length > 0 ? [...value] : []
    remove(newFiles, f => get(f, 'file.path') === file.path && get(f, 'file.lastModified') === file.lastModified)
    delete progress[file.name]
    setSuccess(newFiles.length > 0)
    onFileDeleted(newFiles)
  }

  const err = isArray(errorText) ? get(errorText, '[0]') : isObject(errorText) ? get(errorText, 'location') : errorText

  return (
    <StyledFileUpload>
      <FileUpload
        disabled={disabled}
        files={fileList}
        label={label}
        maxSize={maxSize}
        multipleFiles={multiple}
        handleDrop={files => {
          setProgress({})
          setUploading(true)
          onFileUploading()

          // clear previous data as only the new files would be sent back to the page from now on
          uploadedFiles.length = 0
          /* eslint-disable-next-line guard-for-in, no-restricted-syntax, prefer-const */
          for (const key in progressSync) {
            delete progressSync[key]
          }

          files.map(file => {
            const singleProgress = {
              state: 'pending',
              percentage: 0,
              onCancel: () => {},
            }
            setUploadProgress(file.name, singleProgress)
            upload({
              file,
              info: {
                loggedInUser: formData.userId || 'not specified',
                objectId: formData.objectId || formData.profileId || '',
                objectName: formData.objectName || 'fileUpload',
                component: formData.pageName || 'File Upload',
                formId: formData.form || '',
                action: 'upload',
                target: formData.target || label || '',
                funcName: 'FileUpload',
                application: formData.application || '',
              },
              url: formData.documentUploadEndpoint,
            })
              .then(response => {
                uploadedFiles.push({ ...response, file })
                setUploadProgress(file.name, {
                  percentage: 100,
                  state: 'done',
                })
                if (uploadedFiles.length === Object.keys(progressSync).length) {
                  setSuccess(true)
                  setUploading(false)
                  // biome-ignore lint/performance/noAccumulatingSpread: TODO
                  setFiles(uploadedFiles.reduce((a, f) => ({ ...a, [f.name]: f.key }), {}))
                  onFileUploaded(uploadedFiles)
                }
              })
              // biome-ignore lint/correctness/noUnusedVariables: TODO
              .catch(e => {
                setError(`Upload failed: ${file.name}`)
                onFileUploaded(undefined)
              })
          })
        }}
        uploadProgress={progress}
        uploading={uploading}
        successfulUpload={success}
        errorText={error || err}
        onCancel={onCancel}
        onDelete={onDelete}
        isRequired={isMandatory}
        {...rest}
      />
    </StyledFileUpload>
  )
}

export default Component
